import createActionCreators from 'redux-resource-action-creators';

import * as eff from 'redux-saga/effects';

import {
  actionTypes,
} from '../actions';
import {
  throwError,
  getEntityType,
} from './helpers';

import api from '../api';

const entities = {
  exercises: 'exercises',
  workouts: 'workouts',
  programs: 'programs',
};

export default function* headerFlow(reportChannel) {
  function* referFriend(
    {
      callbacks,
      payload,
    },
  ) {
    try {
      const response = yield eff.call(
        api.postPros,
        {
          body: payload,
        },
      );
      if (callbacks) {
        callbacks.setSubmitting(false);
        callbacks.onSuccess(response);
      }
      if (callbacks?.setSubmitting) callbacks.setSubmitting(false);
      if (callbacks?.onSuccess) callbacks.onSuccess(response);
    } catch (e) {
      if (callbacks?.setSubmitting) callbacks.setSubmitting(false);
      if (callbacks?.onError) callbacks.onError(e);
      yield eff.call(throwError, e);
    }
  }

  function* searchQuery({
    params,
    tabName,
  }) {
    const actions = createActionCreators('read', {
      resourceType: 'searchResults',
      requestKey: 'getSearchResults',
    });

    yield eff.put(actions.pending());

    try {
      const response = yield eff.call(
        api.searchQuery,
        {
          qs: {
            ...params,
            entity_type: tabName || 'all',
            search_scope: 'public',
          },
        },
      );
      const result = response.reduce((acc, entity) => {
        if (entities[entity.title.toLowerCase()]) {
          return acc.concat(
            entity.items.map(item => ({
              ...item,
              entityType: entities[entity.title.toLowerCase()],
            })),
          );
        }
        return acc;
      }, []);

      yield eff.put(actions.succeeded({
        resources: result,
        list: tabName || 'all',
        mergeListIds: false,
      }));
    } catch (e) {
      yield eff.put(actions.failed({
        resources: [],
      }));
      yield eff.call(throwError, e);
    }
  }

  function* addToLibrary({
    entityId,
    folderId,
    resourceType,
    callbacks,
  }) {
    const actions = createActionCreators('read', {
      resourceType,
      requestKey: 'addToLibrary',
    });

    yield eff.put(actions.pending());

    try {
      const response = yield eff.call(
        api.duplicateEntity,
        {
          type: getEntityType(resourceType),
          body: {
            ids: [entityId],
            folder_ids: [folderId],
          },
        },
      );

      yield eff.put(actions.succeeded({
        resources: response,
        list: 'library',
      }));

      yield eff.put(
        reportChannel,
        {
          messageType: 'notify',
          message: {
            type: 'success',
            key: 'item.search_result_added',
          },
        },
      );

      if (callbacks?.setSubmitting) callbacks.setSubmitting(false);
      if (callbacks?.onSuccess) callbacks.onSuccess(response);
    } catch (e) {
      if (callbacks?.setSubmitting) callbacks.setSubmitting(false);
      yield eff.put(actions.failed({
        resources: [],
      }));

      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_REFER_FRIEND, referFriend);
  yield eff.takeEvery(actionTypes.REQUEST_SEARCH_QUERY, searchQuery);
  yield eff.takeEvery(actionTypes.REQUEST_ADD_TO_LIBRARY, addToLibrary);
}
